import createClient from "openapi-fetch";
import type { paths } from "./schema";

/** The API, typed from openapi/analyst.json. Components use the hooks in ./hooks, never this directly. */
// Same-origin; absolute where a location exists, since Request needs an absolute URL outside a browser page.
// fetch is looked up per call, so a test's request interception applies after this module loads.
export const api = createClient<paths>({ baseUrl: globalThis.location?.origin ?? "", fetch: (request) => globalThis.fetch(request) });

let csrfToken: string | null = null;

/** The session's CSRF token, sent on every write; set from /auth/session. */
export function setCsrfToken(token: string | null): void {
  csrfToken = token;
}

api.use({
  onRequest({ request }) {
    if (request.method !== "GET" && csrfToken && !request.headers.has("x-analyst-csrf")) request.headers.set("x-analyst-csrf", csrfToken);
    return request;
  },
});

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

/** The data of a successful call, or an ApiError with the server's code and message. */
export function unwrap<T>(result: { data?: T; error?: unknown; response: Response }): T {
  if (result.response.ok) return result.data as T;
  const body = result.error as { error?: { code?: string; message?: string } } | undefined;
  throw new ApiError(result.response.status, body?.error?.code ?? "error", body?.error?.message ?? `Request failed (${result.response.status})`);
}
